import React, { useState } from 'react';
import { Footer } from '../../Components/Footer';
import OrangeButton from '../../Components/buttons/orange-button';
import HeroContainer from '../../Components/ui/hero-container';
import PriceSlider from '../tutor/components/PriceSlider';
import SearchTutorInput from '../tutor/components/SearchTutorInput';
import Pagination from '../../Components/ui/pagination';
import HeaderAlt from '../../Components/HeaderAlt';
import MultiSelectDropdown from './components/MultiSelectDrowdown';
import SessionOfferCard from './components/SessionOfferCard';
import { sessions } from './data/OfferingData';
import { useNavigate } from 'react-router-dom';
const steps = [
  {
    icon: (
      <img
        src="/images/icons/binoculars.svg"
        alt="binoculars"
        className="h-12 w-12 text-[#5CD2C6]"
      />
    ),
    text: 'Find a suitable tutor',
  },
  {
    icon: (
      <img src="/images/icons/headset.svg" alt="headset" className="h-12 w-12 text-[#5CD2C6]" />
    ),
    text: 'Book your first lesson',
  },
  {
    icon: <img src="/images/icons/laptop1.svg" alt="laptop" className="h-12 w-12 text-[#5CD2C6]" />,
    text: 'Subscribe and learn independently',
  },
];

const OfferingBrowserPage = () => {
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();

  const [range, setRange] = useState({ minValue: 10, maxValue: 1000 });
  const [tutorSearchQuery, setTutorSearchQuery] = useState('');

  const [isOpen, setIsOpen] = useState(false);
  const [isSessionOpen, setIsSessionOpen] = useState(false);
  const [isLevelOpen, setIsLevelOpen] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState(['all']);
  const [selectedSession, setSelectedSession] = useState(['all']);
  const [selectedLevel, setSelectedLevel] = useState(['all']);

  const subjectOptions = [
    { id: 'all', name: 'All' },
    { id: 'english', name: 'English' },
    { id: 'french', name: 'French' },
    { id: 'german', name: 'German' },
    { id: 'math', name: 'Math' },
    { id: 'science', name: 'Science' },
    { id: 'calculus', name: 'Calculus' },
    { id: 'computer-science', name: 'Computer Science' },
  ];
  const sessionOptions = [
    { id: 'all', name: 'All Types' },
    { id: 'individualSessions', name: 'Individual Sessions' },
    { id: 'groupSessions', name: 'Group Sessions' },
    { id: 'virtualSessions', name: 'Virtual Sessions' },
    { id: 'inPersonSessions', name: 'In-Person Sessions' },
  ];
  const levelOptions = [
    { id: 'all', name: 'All Levels' },
    { id: 'middleSchool', name: 'Middle School' },
    { id: 'introductory', name: 'High School: Introductory' },
    { id: 'advanced', name: 'High School: Advanced' },
    { id: 'underGraduateIntroductory', name: 'Undergraduate: Introductory' },
    { id: 'upperLevel', name: 'Undergraduate: Upper Level' },
    { id: 'graduate', name: 'Graduate' },
  ];
  return (
    <>
      <HeaderAlt />
      <div className="flex flex-col gap-6 bg-[#f7f7f7]">
        <HeroContainer className="container !mt-10 !bg-[#f7f7f7] md:!mt-[59px] ">
          <div className="w-full max-w-[610px] space-y-6">
            <h1 className="hero-title fredokaOne font-normal !text-[#012E33]">
              Discover Offerings from expert tutors
            </h1>
            <p className="fredoka text-[19px] font-medium leading-[32px]  tracking-[-0.22px] text-[#678285] md:text-[22px]">
              Enrol in top academic offerings provided by vetted tutors
            </p>
          </div>
        </HeroContainer>
        <div className="container flex w-full flex-col gap-4">
          <div className="mx-auto flex w-full flex-col  gap-2 md:flex-row">
            <div className="relative flex min-w-full flex-col gap-5 rounded-[16px] bg-[#f7f7f7] md:flex-row">
              <div className="w-full">
                <SearchTutorInput
                  placeholder="Search Offerings"
                  tutorSearchQuery={tutorSearchQuery}
                  setTutorSearchQuery={setTutorSearchQuery}
                />
              </div>
              <div className="w-full md:w-[261px]">
                <OrangeButton label={'Search'} className="w-full" />
              </div>
            </div>
          </div>
        </div>
        {/* <CustomModal isOpen={showAppointmentModal} onClose={onModalCLose}>
          <BookingModal
            setStep={setStep}
            step={step}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            selectedTime={selectedTime}
            setSelectedTime={setSelectedTime}
            tutorname={tutorName}
            setShowAppointmentModal={setShowAppointmentModal}
          />
        </CustomModal> */}
        {/* <div className='p-4'>
                <Promo />
            </div> */}
        <main className="container space-y-4 rounded-[24px] !pb-6 ">
          {toggle && (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
              <MultiSelectDropdown
                label="Select Subject"
                options={subjectOptions}
                selectedValues={selectedSubjects}
                onSelectionChange={setSelectedSubjects}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                onToggleDropdown={() => setIsOpen(!isOpen)}
                className="w-full"
              />
              <PriceSlider setRange={setRange} range={range} />
              <MultiSelectDropdown
                label="Select Type of Session"
                options={sessionOptions}
                selectedValues={selectedSession}
                onSelectionChange={setSelectedSession}
                isOpen={isSessionOpen}
                setIsOpen={setIsSessionOpen}
                onToggleDropdown={() => setIsSessionOpen(!isSessionOpen)}
                className="w-full"
              />
              <MultiSelectDropdown
                label="Select Grade/Level"
                options={levelOptions}
                selectedValues={selectedLevel}
                onSelectionChange={setSelectedLevel}
                isOpen={isLevelOpen}
                setIsOpen={setIsLevelOpen}
                onToggleDropdown={() => setIsLevelOpen(!isLevelOpen)}
                className="w-full"
              />
            </div>
          )}
          <div
            className="mx-auto flex w-fit cursor-pointer items-center justify-center gap-2"
            onClick={() => setToggle(!toggle)}
          >
            <h2 className="fredoka text-lg font-semibold leading-[1.5] text-[#FC823E] ">
              Advanced Filters
            </h2>
            <img
              src="/images/icons/chevron-down.svg"
              alt=""
              className={`h-4 w-4 transform transition-transform duration-300 ${
                toggle ? 'rotate-180' : ''
              }`}
            />
          </div>

          <div className="mx-auto !mt-12 grid grid-cols-1 content-center gap-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
            {sessions?.map((course, index) => (
              <SessionOfferCard
                key={index}
                course={course}
                className="!w-auto"
                onClick={() => navigate(`/offerings/${course.id}`)}
              />
            ))}
          </div>
          <div className="!mt-10">
            <Pagination
              data={sessions} // Pass full array
              itemsPerPage={4} // Number of items per page
              // onPageChange={handlePageChange} // Callback to get paginated data
            />
          </div>
        </main>
        <div className="flex w-full flex-col items-center justify-center !space-y-16 rounded-2xl  bg-[#85D7D6] py-8 md:py-12">
          <h2 className="fredoka container text-center text-[40px] font-bold leading-normal tracking-[-0.8px] text-[#012E33]">
            How Tutoring <br /> Works
          </h2>
          <div className="container !mt-6 grid w-full grid-cols-1 gap-12 md:grid-cols-3 md:gap-0">
            {steps.map((step, index) => (
              <div key={index} className="flex flex-col items-center">
                <div className="mb-4 flex h-32 w-32 items-center justify-center rounded-full bg-white">
                  {step.icon}
                </div>
                <p className="fredoka text-wrap text-center text-[22px] font-medium leading-normal tracking-[-0.44px] text-[#012E33]">
                  {step.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OfferingBrowserPage;
